import * as PIXI from "pixi.js";
import PointAnswerConFactory from "./PointAnswerConFactory";
import TestQuestionManager from "../../TestQuestionManager/TestQuestionManager";
import { TSwtButEventBusNames } from "../../../types/Config";
import { rootEventBus, EnumRootEventBus } from "../../../../../../../src/managers/RootEventBus";
import { QuestionType } from "../../../types/Enum";
import { PointAnswer } from "../../../types/Interface";
import { eventBus, EnumEventBus } from "../../EventBus";


export default class PointAnswerCon extends PIXI.Container {
  private TestQuestionManager = TestQuestionManager.getInstance();

  constructor() {
    super();
    this.addSwitchers();

    eventBus.on(EnumEventBus.showTestQuestion, (i: number) => this.showforAnswer(i))
  }
  addSwitchers() {
    PointAnswerConFactory.genDirectionButton(this);
    PointAnswerConFactory.genRotationButton(this);
  }
  setButtons = (v: boolean) => PointAnswerConFactory.setAnswerButtons(this, v);
  reset() {
    this.setButtons(true);
    rootEventBus.emit(EnumRootEventBus.topSwitcherButtonLabel, TSwtButEventBusNames.dirBut, "");
    rootEventBus.emit(EnumRootEventBus.topSwitcherButtonLabel, TSwtButEventBusNames.rotBut, "");
  }
  showforAnswer(index: number) {
    let answer = this.TestQuestionManager.getAnswer(index);

    if (answer.type == QuestionType.TYPE1) {
      return this.visible = false;
    }

    this.visible = true;
    this.setButtons(true);
    const ans: PointAnswer = answer as PointAnswer;

    rootEventBus.emit(EnumRootEventBus.topSwitcherButtonLabel, TSwtButEventBusNames.dirBut, ans.direction || "");
    rootEventBus.emit(EnumRootEventBus.topSwitcherButtonLabel, TSwtButEventBusNames.rotBut, (ans.rotation || "").toString());
  }
}